import $ from "jquery";
import CookieConsent from "@alpaga/cookie-consent";
import { carouselWrapper } from "./helpers/CarouselWrapper";
import "./../styles/main.scss";
import Siema from "siema";
require("jquery.scrollto");
require('./woocommerce/Global');
// require("./helpers/ihavecookies");
$(document).ready(function () {
    carouselWrapper();
    $.extend($.scrollTo.defaults, {
        axis: 'y'
    });
    if ($('.siema').length) {
        $(".siema").each(function (k, v) {
            var navigation = $(v).next(".navigation");
            var hasTimer = true;
            var interval;
            var siema = new Siema({
                selector: v,
                duration: 200,
                easing: 'ease-out',
                perPage: 1,
                startIndex: 0,
                draggable: true,
                multipleDrag: true,
                threshold: 20,
                loop: true,
                onInit: function () {
                    navigation.find("span:eq(0)").addClass("current");
                },
                onChange: function () {
                    if (hasTimer) {
                        clearInterval(interval);
                        interval = setInterval(function () { return siema.next(); }, 5000);
                    }
                    navigation.find(".current").removeClass("current");
                    navigation.find("span:eq(" + siema.currentSlide + ")").addClass("current");
                }
            });
            navigation.on("click", "span", function (e) {
                e.preventDefault();
                siema.goTo($(e.currentTarget).index());
            });
            $(".left").on('click', function (e) { e.preventDefault(); siema.prev(); });
            $(".right").on('click', function (e) { e.preventDefault(); siema.next(); });
        });
        // setInterval(() => siema.next(), 3000)
    }
    if ($(".page-template-tpl-faq").length) {
        $('#questions').on("click", ".action a", function (e) {
            e.preventDefault();
            $(e.currentTarget).parents("li").toggleClass("open");
            $(e.currentTarget).parent().parent().next().slideToggle(300);
        });
    }
    var CookieConsentNode = new CookieConsent({
        locale: "fr",
        content: {
            link: "/politique-de-confidentialite/",
            banner: {
                title: "En utilisant ce site, vous acceptez l'utilisation des cookies."
            },
            popup: {
                title: "Ce site utilise des cookies.",
                description: "Ce site utilise des cookies. Nous utilisons des cookies pour que notre site web fonctionne au mieux, améliorant ainsi votre expérience en ligne. Afin d’en savoir plus sur l’utilisation des cookies, les plug-ins pour les réseaux sociaux ainsi que le web tracking, n’hésitez pas à consulter notre page d’informations sur les Cookies ainsi que notre Déclaration de Protection des Données."
            }
        },
        cookies: {
            'necessary': {
                name: "necessary",
                disabled: true,
                value: true,
                title: "Cookies nécessaires",
                description: "Les cookies nécessaires aident à rendre un site Web utilisable en activant de base \
                des fonctions telles que la navigation sur les pages et l'accès aux zones sécurisées du site Web. Le site Web ne peut pas \
                fonctionner correctement sans ces cookies.",
                "function": function () { },
                cookies: [
                    {
                        name: "CookieConsent",
                        provider: "cookieconsent.extension",
                        purpose: "Stocke l'état de consentement des cookies de l'utilisateur pour le domaine actuel",
                        expiry: "1 an",
                        type: "HTTP"
                    },
                ]
            },
            analytics: {
                name: "analytics",
                value: true,
                title: "Analytics Cookies",
                "function": function () {
                    analyticsFn();
                },
                description: "Les cookies analytiques aident les propriétaires de sites Web à comprendre comment les visiteurs \
                interagir avec les sites Web en collectant et en signalant des informations de manière anonyme.",
                cookies: [
                    {
                        name: "_ga",
                        provider: "Google",
                        purpose: "Enregistre un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web.",
                        expiry: "2 ans",
                        type: "HTTP"
                    },
                    {
                        name: "_gat",
                        provider: "Google",
                        purpose: "Utilisé par Google Analytics pour réduire le taux de demandes",
                        expiry: "1 jour",
                        type: "HTTP"
                    },
                    {
                        name: "_gid",
                        provider: "Google",
                        purpose: "Enregistre un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web.",
                        expiry: "1 jour",
                        type: "HTTP"
                    }
                ]
            }
        }
    });
    CookieConsentNode.init();
    // const viewCookieBannerButton = document.querySelector(".view-cookie-banner");
    // if (viewCookieBannerButton !== void 0) {
    //     viewCookieBannerButton.addEventListener("click", (e) => {
    //         e.preventDefault();
    //         CookieConsentNode.showDetails();
    //     });
    // }
    $("body").on("click", "a[href^='#goto-']", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href").replace("goto-", "");
        var posY = $(node).offset().top - $("#main-header").height();
        if (posY >= 0) {
            $.scrollTo(posY, 400);
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
    // $("body").on("click", "a[href='#contact']", (e:Event) => {
    //     const elm = $(e.currentTarget).attr("href");
    //     const posY = $(elm).offset().top - $("#main-header").height();
    //     $.scrollTo(posY, 400);
    // });
    $("body").on("click", "a[href^='#']", function (e) {
        var elm = $(e.currentTarget).attr("href");
        if (elm == "#contact") {
            $(".show-menu").removeClass("show-menu");
        }
        var posY = $(elm).offset().top - $("#main-header").height() - 75;
        $.scrollTo(posY, 400);
    });
});
